module.exports = __webpack_public_path__ + "static/media/icon.648ce9c8.svg";